export default __webpack_public_path__ + "990c1b9e5663c700b5939fba903fd7c9.png";